import { Injectable } from '@angular/core';
import * as _ from 'lodash';

@Injectable()

export class FileUtilityService {

  _base64ToArrayBuffer(base64): Uint8Array {
    var binary_string = window.atob(base64);
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes;
  }
  
}



// WEBPACK FOOTER //
// ./src/app/interface/fileUtils.ts